import api from "./api";
import endpoints from "./endpoints";

export default {
  getBaseCatalog: async function (args) {
    const response = await api.get(endpoints.catalogs.baseCatalog.get, {
      params: args
    });
    return response.data;
  },
  getCatalogs: async function ({ language, catalogTypes }) {
    const response = await api.post(endpoints.catalogs.catalog.get, catalogTypes, { params: { language } });
    return response.data;
  },
  getCatalogNames: async function ({ language, catalogTypes }) {
    const response = await api.post(endpoints.catalogs.catalog.getNames, catalogTypes, { params: { language } });
    return response.data;
  },
  getCatalogSettings: async function (args) {
    const { signal, ...params } = args;
    const response = await api.get(endpoints.catalogs.catalog.settings, {
      params: params,
      signal: signal
    });
    return response.data;
  },
  updateCatalogSettings: async function (settings) {
    const response = await api.post(endpoints.catalogs.catalog.updateSettings, settings);
    return response.data;
  },
  getRootNodes: async function (args) {
    const { signal, ...params } = args;
    const response = await api.get(endpoints.catalogs.rootNodes.get, {
      params: params,
      signal: signal
    });
    return response.data;
  },
  getNodes: async function (args) {
    const { signal, ...params } = args;
    const response = await api.get(endpoints.catalogs.nodes.get, {
      params: params,
      signal: signal
    });
    return response.data;
  },
  moveNodes: async function (catalogId, action, nodes, parentId) {
    const response = await api.post(endpoints.catalogs.nodes.move, nodes, {
      params: { catalogId, moveActionType: action, parentId }
    });
    return response.data;
  },
  createNode: async function (args) {
    const response = await api.post(endpoints.catalogs.nodes.create, {}, { params: args });
    return response.data;
  },
  moveNodeToPosition: async function (nodeId, targetNodeId, targetPosition, catalogId, languageCode) {
    const response = await api.post(
      endpoints.catalogs.nodes.moveTo,
      {},
      {
        params: {
          sourceNodeId: nodeId,
          targetNodeId: targetNodeId,
          targetPosition,
          catalogId,
          languageCode
        }
      }
    );
    return response.data;
  },
  deleteNodes: async function (catalogId, nodes) {
    const response = await api.post(endpoints.catalogs.nodes.delete, nodes, {
      params: { catalogId }
    });
    return response.data;
  },
  sortNodes: async function (nodeId, nodeType, sortDirection, catalogId, languageCode) {
    const response = await api.post(endpoints.catalogs.nodes.sort, {}, { params: { nodeId, nodeType, sortDirection, catalogId, languageCode } });
    return response.data;
  },
  rename: async function (uId, nodeId, nodeType, catalogId, name, languageCode) {
    const response = await api.post(endpoints.catalogs.nodes.rename, {}, { params: { uId, nodeId, nodeType, catalogId, name, languageCode } });
    return response.data;
  },
  paste: async function (nodeIds, targetNodeId, isCopy, targetPosition, catalogId, languageCode) {
    const response = await api.post(endpoints.catalogs.nodes.paste, nodeIds, {
      params: { targetNodeId, isCopy, targetPosition, catalogId, languageCode }
    });
    return response.data;
  },
  getChildrenCount: async function (id) {
    const response = await api.get(endpoints.catalogs.baseCatalog.childCount, {
      params: { catalogId: id }
    });
    return response.data;
  },
  deleteCatalog: async function (catalogId) {
    const response = await api.post(endpoints.catalogs.catalog.delete, {}, { params: { catalogId } });
    return response.data;
  },
  deleteCatalogs: async function (catalogIds) {
    const response = await api.post(endpoints.catalogs.catalog.deleteMultiple, catalogIds, { params: {} });
    return response.data;
  },
  renameCatalog: async function (catalogId, name, language, category) {
    const response = await api.post(endpoints.catalogs.catalog.rename, {}, { params: { catalogId, name, languageCode: language, category } });
    return response.data;
  },
  create: async function (name, catalogType, category, isLinkable, languageCode, catalogMappingTargetId, catalogUid) {
    const response = await api.post(
      endpoints.catalogs.catalog.create,
      {},
      {
        params: {
          name,
          catalogType,
          category,
          isLinkable,
          languageCode,
          catalogMappingTargetId,
          catalogUid
        }
      }
    );
    return response.data;
  },
  getCategoris: async function (languageCode) {
    return await api.get(endpoints.catalogs.categoris.get, { params: languageCode }).then((x) => Promise.resolve(x.data));
  },
  getMappingTargets: async function (catalogType) {
    const response = await api.get(endpoints.catalogs.mappingTargets.get, {
      params: catalogType
    });
    return response.data;
  },
  getCatalogMappingProjects: async function (catalogId, language, abortSignal) {
    return api
      .get(endpoints.catalogs.mappingProjects.get, {
        params: { catalogId, language },
        signal: abortSignal
      })
      .then((x) => Promise.resolve(x.data));
  },
  getAllCatalogMappingProjects: async function (language) {
    return api.get(endpoints.catalogs.allMappingProjects.get, { params: { language } }).then((x) => Promise.resolve(x.data));
  },
  getCatalogMappingSourceFieldLocalizations: async function (catalogId, languageCode, abortSignal) {
    const response = await api.get(endpoints.catalogs.catalogMappingSourceFieldLocalizations.get, {
      params: { catalogId, language: languageCode },
      signal: abortSignal
    });
    return response.data;
  },
  checkArticleInBaseCatalog: async function (articleId) {
    const response = await api.get(endpoints.catalogs.articles.existInBaseCatalog, { params: articleId });
    return response.data;
  },
  getCatalogAttributes: async function (catalogId, catalogType, languageCode) {
    const response = await api.get(endpoints.catalogs.catalogAttributes.get, {
      params: { catalogId, catalogType, languageCode }
    });
    return response.data;
  },
  updateCatalogAttributes(id, language, model) {
    return api
      .post(endpoints.catalogs.catalogAttributes.update, model, {
        params: { language, catalogid: id }
      })
      .then((x) => Promise.resolve(x.data));
  },
  checkLinkedNodesExists: async function (catalogId) {
    const response = await api.get(endpoints.catalogs.catalog.checkLinkedNodesExists, { params: { catalogId } });
    return response.data;
  },
  pasteToAnotherCatalog: async function (nodeIds, targetNodeId, sourceCatalogId, targetCatalogId, isPasteAsLink, targetPosition, languageCode) {
    const response = await api.post(endpoints.catalogs.nodes.pasteToAnothercatalog, nodeIds, {
      params: {
        targetNodeId,
        sourceCatalogId,
        targetCatalogId,
        isPasteAsLink,
        targetPosition,
        languageCode
      }
    });
    return response.data;
  },
  createCatalogMappingProject: async function (name, catalogId, catalogMappingTargetId) {
    const response = await api.post(endpoints.catalogs.mappingProjects.create, {}, { params: { name, catalogId, catalogMappingTargetId } });
    return response.data;
  },
  copyCatalog: async function (catalogId, language, copyAsStandard = false) {
    const response = await api.post(endpoints.catalogs.catalog.copy, {}, { params: { catalogId, language, copyAsStandard } });
    return response.data;
  },
  getMappingTargetNodes: async function (catalogMappingTargetId, mappingProjectId, abortSignal) {
    const response = await api.get(endpoints.catalogs.targetMappingNodes.get, {
      params: { catalogMappingTargetId, mappingProjectId },
      signal: abortSignal
    });
    return response.data;
  },
  createSnapShot: async function (catalogId, language, remarks) {
    const response = await api.post(endpoints.catalogs.snapshot.create, {}, { params: { catalogId, language, remarks } });
    return response.data;
  },
  getSnapshotHistory: async function (catalogId, language) {
    const response = await api.get(endpoints.catalogs.snapshot.get, {
      params: { catalogId, language }
    });
    return response.data;
  },
  getSnapshotHistoryMultiple: async function (catalogIds, language) {
    const response = await api.post(endpoints.catalogs.snapshot.multiple, catalogIds, { params: { language } });
    return response.data;
  },
  restoreSnapShot: async function (snapshotCatalogId, language) {
    const response = await api.post(endpoints.catalogs.snapshot.restore, {}, { params: { snapshotCatalogId, language } });
    return response.data;
  },
  copySnapShot: async function (snapshotCatalogId, language) {
    const response = await api.post(
      endpoints.catalogs.snapshot.copy,
      {},
      {
        params: {
          catalogSnapshotId: snapshotCatalogId,
          languageCode: language
        }
      }
    );
    return response.data;
  },
  deleteSnapShots: async function (listOfSnapshotIds) {
    const response = await api.post(endpoints.catalogs.snapshot.delete, listOfSnapshotIds, { params: {} });
    return response.data;
  },
  deleteMappingProject: async function (catalogMappingProjectId) {
    const response = await api.post(endpoints.catalogs.mappingProjects.delete, {}, { params: { catalogMappingProjectId } });
    return response.data;
  },
  renameMappingProject: async function (name, catalogId, catalogMappingProjectId) {
    const response = await api.post(endpoints.catalogs.mappingProjects.rename, {}, { params: { name, catalogId, catalogMappingProjectId } });
    return response.data;
  },
  copyMappingProject: async function (catalogId, catalogMappingProjectId, languageCode) {
    const response = await api.post(endpoints.catalogs.mappingProjects.copy, {}, { params: { catalogId, catalogMappingProjectId, languageCode } });
    return response.data;
  },

  async generateFromExternalData(language, data) {
    const response = await api.post(endpoints.catalogs.catalog.generateFromExternalData, data, { params: { language } });
    return response.data;
  },
  /**
   * @param {object} data
   */
  async generateCatalogFromFile(language, data) {
    const response = await api.post(endpoints.catalogs.catalog.generateFromFile, data, { params: { language } });
    return response.data;
  },

  /**
   * @param  {string} catalogName
   * @param {object} data
   */
  async downloadNonExistingArticles(catalogName, data) {
    const response = await api.post(endpoints.catalogs.catalog.downloadNonExistingArticles, data, { params: { catalogName } });
    return response.data;
  },

  /**
   * @param {string} sourceCatalogId
   * @param {string} advancedSearchId
   * @param {string} newCatalogName
   * @param {string} language
   * @param {string} connectionId
   */
  async generateCatalogFromFilter(sourceCatalogId, newCatalogName, advancedSearchId, language, connectionId) {
    const response = await api.post(
      endpoints.catalogs.catalog.generateFromFilter,
      {},
      { params: { sourceCatalogId, advancedSearchId, newCatalogName, language, connectionId } }
    );
    return response.data;
  },
  resolveLinkedCatalogNode: async function (catalogId, linkedCatalogNodeId) {
    const response = await api.post(
      endpoints.catalogs.nodes.resolveLinkedCatalogNode,
      {},
      {
        params: {
          catalogId,
          linkedCatalogNodeId
        }
      }
    );
    return response.data;
  }
};
